// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"vw_a bhb_b"};